import { Component, OnInit } from '@angular/core';
import { HotelModel } from 'src/app/views/models/hotel.model';
import { UserService } from '../../../../provider/user.service';

@Component({
  selector: 'kt-change-hotel',
  templateUrl: './change-hotel.popup.html',
  styleUrls: ['./change-hotel.popup.scss']
})
export class ChangeHotelPopup implements OnInit {
  filter: HotelModel[];
  data: HotelModel[];

  constructor(
    private userService: UserService
  ) {
  }

  async ngOnInit() {
    const HOTELS = await this.userService.getHotels();
    console.log(HOTELS);


    this.filter = HOTELS;
    this.data = HOTELS;
  }

  changeFilter(event) {
    const val = event.target.value.toLowerCase();
    this.filter = this.data;

    this.filter = this.data.filter((d) => {
      return d.HotelName.toLowerCase().indexOf(val) !== -1 || !val;
    });
  }

  select(item: HotelModel) {
    const USER = this.userService.record_change$.getValue();
    USER.app_hotel_id = item.ID;
    localStorage.setItem('hotelId', item.ID.toString());
    this.userService.putUser(USER);
  }
}
